import {useQuery} from '@apollo/react-hooks';
import {gql} from 'graphql-tag';

import {useRampFlagIssuesObservability} from '../../../util/rampFeatureFlags';

const NodeAlertFragment = gql`
  fragment NodeAlertFragment on NodeAlert {
    alertName
    alertStatus
    cluster
    clusterOrg
    node
    pod
    occurrences
  }
`;

const RunIssueQuery = gql`
  query RunIssueQuery(
    $entityName: String!
    $projectName: String!
    $runName: String!
  ) {
    project(entityName: $entityName, name: $projectName) {
      id
      run(name: $runName) {
        id
        # TODO: Remove @client directive when run issues are implemented
        nodeAlertsHistory @client {
          ...NodeAlertFragment
        }
      }
    }
  }
  ${NodeAlertFragment}
`;

type UseRunIssuesOpts = {
  entityName: string;
  projectName: string;
  runName: string;
};
export function useRunIssues({
  entityName,
  projectName,
  runName,
}: UseRunIssuesOpts) {
  const canQueryIssues = useRampFlagIssuesObservability(
    entityName,
    projectName
  );

  return useQuery(RunIssueQuery, {
    variables: {
      entityName,
      projectName,
      runName,
    },
    skip: !canQueryIssues,
  });
}
